

import { adminRequests } from "@/admin/adminRequests";
import { sessionData } from "@/data/sessionData";
import { supabase } from "@/data/supabaseInstance";
import { userData } from "@/data/userData";
import { environment } from "@/environment/environment";
import { PreLoginRequest, ResponseCreateNewUser, UserData } from "@/interfaces/types";
import router from "@/router/router";
import axios from "axios";
import { storeToRefs } from "pinia";
import { toRefs } from "vue";
import { userRequests } from "./userRequests";

const { getUser, verifyJWT } = userRequests()


const {
    apiUrl: baseUrlBackend,
    wooCommerceUrl: wooUrl
} = environment
const {
    frontendUrl: frontUrl,
    apiUrl: baseUrl,
} = environment

export function loginRequest() {



    const signup = async (firstName: string, lastName: string, email: string, pwd: string, language: string, country: string, city: string, street: string, zipCode: number, tel: number): Promise<ResponseCreateNewUser | null> => {
        try {
            const response = await axios.post(`${baseUrl}/user/signup`,
                {
                    firstName: firstName,
                    lastName: lastName,
                    username: email,
                    email: email,
                    pwd: pwd,
                    language: language,
                    country: country,
                    city: city,
                    street: street,
                    zipCode: zipCode,
                    tel: tel
                }
            );
            return await response.data as ResponseCreateNewUser
        } catch (error: any) {
            console.log("🚀 ~ signup ~ errors:", error);

            if (error.response && error.response.data) {
                return error.response.data as ResponseCreateNewUser;
            }

            return null;
        }
    }

    // return true if no rateLimitig was exceeded
    const preLogin = async (email: string): Promise<PreLoginRequest | boolean> => {
        try {
            const response = await axios.get(`${baseUrl}/user/preLogin`, {
                params: {
                    email: email
                }
            })
            return response.data
        } catch (error) {
            return false
        }
    }

    const login = async (email: string, password: string): Promise<boolean> => {
        const sessionStore = sessionData()
        const { validSession } = toRefs(sessionStore)

        const { data } = await supabase.auth.signInWithPassword({
            email: email,
            password: password,
        })
        validSession.value = !!data.session
        return !!data.session
    }

    const logout = async () => {
        const sessionStore = sessionData()
        const userStore = userData()
        const { validSession } = storeToRefs(sessionStore)

        const { user } = storeToRefs(userStore)
        try {
            await supabase.auth.signOut({ scope: 'global' })
        } catch (errors) {
            console.error('Error by logout:', errors);
        }

        localStorage.removeItem('sidebarData')
        localStorage.removeItem('policyStore')
        localStorage.removeItem('mobileStore')
        localStorage.removeItem('incidentStore')
        localStorage.removeItem('access')

        sessionStore.validSession = false
        sessionStore.intentionalLogout = true
        validSession.value = false
        user.value.id = -1
    };

    const resetPassword = async (password: string, access_token: string | null, refresh_token: string | null): Promise<string | null> => {
        try {

            if (!access_token || !refresh_token) {
                console.error('Access token or refresh token missing');
                return null;
            }

            const { error: sessionError } = await supabase.auth.setSession({ access_token, refresh_token });

            if (sessionError) {
                console.error("Session error", sessionError);
                return null;
            }

            const { data, error } = await supabase.auth.updateUser({
                password: password
            });

            if (error || !data?.user?.email) {
                console.error("Error updating the password", error);
                return null;
            }

            return data.user.email
        } catch (errors) {
            console.error('Error by logout:', errors);
            return null
        }
    };

    const requestResetPassword = async (email: string): Promise<boolean> => {

        const { error, data } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: `${frontUrl}/resetpwd`,
        })

        if (error) {
            console.log("🚀 ~ loginRequest ~ requestResetPassword ~ error: User", email, error)
        }
        return !!data && !error
    };

    const getUserData = async (): Promise<UserData | null> => {

        const sessionStore = sessionData()
        const { validSession, intentionalLogout } = toRefs(sessionStore)

        try {
            if (validSession.value) {
                const { data, error } = await supabase.auth.getSession()
                if (error || !data.session?.user?.email) {
                    localStorage.clear()
                    intentionalLogout.value = false
                    validSession.value = false
                    router.push({ name: "Landing page" })
                    return null
                }

                const validJWT = await verifyJWT(data.session.access_token)
                if (!validJWT) {
                    localStorage.clear()
                    intentionalLogout.value = false
                    validSession.value = false
                    router.push({ name: "Landing page" })
                    return null
                }
                return await getUser(data.session.user.email)
            }
            localStorage.clear()
            validSession.value = false
            router.push({ name: "Landing page" })
            return null
        } catch (error) {
            console.log("🚀 ~ loginRequest ~ getUserData ~ error:", error)
            return null
        }
    }

    // TODO dynamic shop url. Set the user category for the specific licence and redirect
    const setSSOwpSupabase = async (): Promise<boolean> => {
        try {

            const { data, error } = await supabase.auth.getSession()

            if (!data || !data.session || !data.session.access_token || error || !data.session?.user?.email) {
                return false
            }
            const resp = await fetch(`${wooUrl}wp-login-api-sso.php`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: data.session.user.email }),
            });

            if (!resp.ok) return false

            return true
        } catch (error) {
            console.log("🚀 ~ loginRequest ~ setSSOwpSupabase ~ error:", error)
            return false
        }
    }


    const changePwdWordPress = async (email: string, pwd: string): Promise<Boolean> => {

        try {
            const response = await axios.post(`${baseUrl}/user/changePwd`, {
                email: email, pwd: pwd
            })
            return response.data
        } catch (error) {
            console.log("🚀 ~ loginRequest ~ changePwdWordPress ~ error:", error)
            return false
        }
    }

    const existingEmail = async (email: string): Promise<Boolean> => {

        try {
            const response = await axios.post(`${baseUrl}/user/existingEmail`, {
                email: email
            })
            return response.data
        } catch (error) {
            console.log("🚀 ~ loginRequest ~ existingEmail ~ error:", error)
            return false
        }
    }

    const deleteAccount = async () => {


        const sessionStore = sessionData()
        const { intentionalLogout, validSession } = toRefs(sessionStore)
        const { blockAccount } = adminRequests()
        try {
            const { data, error } = await supabase.auth.getSession()
            if (error || !data.session?.user?.email) {
                intentionalLogout.value = false
                validSession.value = false
                router.push('/landingPage')
                return null
            }
            await sendDeleteAccountEmail(data.session.user.email)
            await blockAccount(data.session.user.id, data.session.user.email)
            localStorage.clear()
            router.push('/landingPage')
            window.location.reload()
        } catch (error) {
            console.log("Error by delete account", error)
        }
    }

    // set dismiss account value to true in BE
    const sendDeleteAccountEmail = async (email: string) => {
        try {
            await axios.get(`${baseUrlBackend}/user/deleteAccount`, {
                params: {
                    email: email
                }
            })
        } catch (error) {
        }
    }

    const resendConfEmail = async (email: string) => {
        const { data, error } = await supabase.auth.resend(
            { type: 'signup', email: email }
        )
        console.log(data, error)
    }

    return {
        login,
        logout,
        resetPassword,
        requestResetPassword,
        getUserData,
        signup,
        changePwdWordPress,
        existingEmail,
        deleteAccount,
        resendConfEmail,
        setSSOwpSupabase,
        preLogin
    }
}
